import { Progress } from "antd";
import React from "react";
import "./style.scss";
const ProgressUsage = ({
   usagePercentage,
   usedStorageGB,
   availableStoragePercentage,
   fieldType
}) => {
   return (
      <>
         <label className="labelAmountContainer">{fieldType}</label>
         <div className="customProgress position-relative text-center">
            <Progress 
               type="circle"
               percent={Number(usagePercentage)}
               width={150}
               strokeColor="#003DAA"
               format={() => `${usedStorageGB}GB`}
            />
            <div className="availableStoragePercentage">
               {/* usagePercentage here if you want to display the used percentage */}
               {availableStoragePercentage}%
            </div>
         </div>
         <div className="available-used-container d-flex justify-content-center">
            <div className="d-flex align-items-center" style={{ gap: "5px" }}>
               <span className="available-span"></span>
               <span className="available-used-text">Available</span>
            </div>
            <div className="d-flex align-items-center" style={{ gap: "5px" }}>
               <span className="used-span"></span>
               <span className="available-used-text">Used</span>
            </div>
         </div>
      </>
   );
};
export default ProgressUsage;
